// src/utils/metaPixel.js

export const trackPageView = () => {
    if (window.fbq) {
        window.fbq('track', 'PageView');
    }
};

export const trackViewContent = (product) => {
    if (window.fbq && product) {
        window.fbq('track', 'ViewContent', {
            content_ids: [product.idProducto || product.referencia],
            content_name: product.nombreOriginal || product.nomProducto,
            content_type: 'product',
            value: typeof product.precioU === 'string' ? parseFloat(product.precioU.replace(/[^0-9,-]+/g, '')) : (product.precioU || 0),
            currency: 'COP' // Moneda por defecto (Colombia)
        });
    }
};

export const trackAddToCart = (product, quantity = 1) => {
    if (window.fbq && product) {
        const value = typeof product.precioU === 'string' ? parseFloat(product.precioU.replace(/[^0-9,-]+/g, '')) : (product.precioU || 0);
        window.fbq('track', 'AddToCart', {
            content_ids: [product.idProducto || product.referencia],
            content_name: product.nombreOriginal || product.nomProducto,
            content_type: 'product',
            value: value * quantity,
            currency: 'COP'
        });
    }
};

export const trackRemoveFromCart = (product) => {
    if (window.fbq && product) {
        const value = typeof product.precioU === 'string' ? parseFloat(product.precioU.replace(/[^0-9,-]+/g, '')) : (product.precioU || 0);
        window.fbq('trackCustom', 'RemoveFromCart', {
            content_ids: [product.idProducto || product.referencia],
            content_name: product.nombreOriginal || product.nomProducto,
            content_type: 'product',
            value: value,
            currency: 'COP'
        });
    }
};

export const trackInitiateCheckout = (totalValue, numItems) => {
    if (window.fbq) {
        window.fbq('track', 'InitiateCheckout', {
            value: totalValue,
            currency: 'COP',
            num_items: numItems
        });
    }
};
